import { IProduct } from 'src/common/types/CatalogType';
import {
  getEnvironment,
  getPrice,
} from 'src/services/googleAnalytics/enhancedEcommerce/helpers';
import {
  EnhancedEcommerceEvents,
  IEnhancedEcommerceEvent,
} from 'src/services/googleAnalytics/enhancedEcommerce/types';

export const sendProductDetailEvent = (product: IProduct) => {
  const productDetailEvent: IEnhancedEcommerceEvent = {
    event: EnhancedEcommerceEvents.productDetail,
    // TODO: remove getEnvironment helper and replace it by common content variables;
    ambiente: getEnvironment(process.env.BRAND_IDENTIFIER),
    ecommerce: {
      detail: {
        products: [
          {
            brand: product.brand,
            category: product.category,
            id: product.sku,
            name: product.name,
            price: getPrice(product.price, product.discountPrice),
          },
        ],
      },
    },
  };
  window.dataLayer.push(productDetailEvent);
};
